export default __webpack_public_path__ + "static/media/main_s.df6c2e77.jpg";